module.exports = __webpack_public_path__ + "static/media/ios-expand.8d6acbb6.svg";